import React, { useState } from "react";

export function PageLoader() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        gap: "16px",
        background: "#f8fafc",
      }}
    >
      <div
        style={{
          width: "48px",
          height: "48px",
          border: "4px solid #e2e8f0",
          borderTopColor: "#000F45",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
        }}
      />
      <p style={{ color: "#64748b", fontWeight: "500", fontSize: "0.95rem" }}>
        Loading...
      </p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export function ModelLoaderOverlay({ progress, onRetry }) {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = () => {
    setRetrying(true);
    onRetry?.();
    setTimeout(() => setRetrying(false), 1500);
  };

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(241, 245, 249, 0.95)",
        zIndex: 50,
        borderRadius: "inherit",
        gap: "16px",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          border: "3px solid #e2e8f0",
          borderTopColor: "#000F45",
          borderRadius: "50%",
          animation: "spin 0.7s linear infinite",
        }}
      />
      {typeof progress === "number" && progress >= 0 && progress < 100 && (
        <div
          style={{
            width: "160px",
            height: "4px",
            background: "#e2e8f0",
            borderRadius: "2px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${Math.min(100, progress)}%`,
              height: "100%",
              background: "#000F45",
              transition: "width 0.2s ease",
            }}
          />
        </div>
      )}
      {typeof progress === "number" && progress >= 0 && (
        <span style={{ fontSize: "13px", color: "#64748b", fontWeight: "500" }}>
          {progress < 100 ? `${Math.round(progress)}%` : "Ready"}
        </span>
      )}
      {onRetry && (
        <button
          type="button"
          onClick={handleRetry}
          disabled={retrying}
          style={{
            padding: "8px 16px",
            fontSize: "13px",
            fontWeight: "600",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
            background: "#fff",
            color: "#64748b",
            cursor: retrying ? "not-allowed" : "pointer",
            opacity: retrying ? 0.7 : 1,
          }}
        >
          {retrying ? "Retrying…" : "Retry"}
        </button>
      )}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default PageLoader;
